import { logger } from '@adornis/base/logging.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { startWatcherForExam, stopWatcherForExam } from '../../server/suggestions/examStateWatcherManager.js';

export const startExamWatcherMutation = registerMutation({
  operationName: 'startExamWatcher',
  type: () => Boolean,
  params: [{ name: 'examId', type: () => String }],
  resolve: (examId: string) => async () => {
    if (!examId) throw new Error('examId required');
    try {
      await startWatcherForExam(examId, { debounceMs: 100 });
      return true;
    } catch (err) {
      logger.error({ err, examId }, 'Failed to start watcher for exam');
      return false;
    }
  },
});

export const stopExamWatcherMutation = registerMutation({
  operationName: 'stopExamWatcher',
  type: () => Boolean,
  params: [{ name: 'examId', type: () => String }],
  resolve: (examId: string) => async () => {
    if (!examId) throw new Error('examId required');
    try {
      stopWatcherForExam(examId);
      return true;
    } catch (err) {
      logger.error({ err, examId }, 'Failed to stop watcher for exam');
      return false;
    }
  },
});

export default { startExamWatcherMutation, stopExamWatcherMutation };
